import { useMemo } from 'react'
import { ACCREDITATION_TYPE, LLOTJA_WORKFLOW_STATE } from '../utils/constants'
import { getEmailFromToken } from '../utils/utils'
import { useEdition } from './useEdition'
import { useGuillotina } from './useGuillotina'

export function useAccreditacioEntities() {
  const { edition } = useEdition()
  const email = getEmailFromToken()

  const { data, isLoading, error } = useGuillotina({
    path:
      email && edition
        ? `@search?type_name=Ens&tipus__in=artista,representant&owners=${email}&_sort_des=creation_date`
        : null,
  })

  const { performing, nonPerforming } = useMemo(() => {
    if (!data?.items) return { performing: [], nonPerforming: [] }
    const editionEntities = data.items.filter((e) => e.path?.startsWith(`/${edition}/`))
    return {
      performing: editionEntities.filter((e) => e.review_state === LLOTJA_WORKFLOW_STATE.published),
      nonPerforming: editionEntities.filter(
        (e) => e.review_state !== LLOTJA_WORKFLOW_STATE.published
      ),
    }
  }, [data, edition])

  const accreditationCase =
    performing.length > 0
      ? ACCREDITATION_TYPE.performing
      : nonPerforming.length > 0
      ? ACCREDITATION_TYPE.non_performing
      : null

  return { performing, nonPerforming, accreditationCase, loading: isLoading, error }
}
